import { render } from "./StaticTableFormater.vue?vue&type=template&id=14853d46&ts=true"
import script from "./StaticTableFormater?vue&type=script&lang=ts&external"
export * from "./StaticTableFormater?vue&type=script&lang=ts&external"

import "./StaticTableFormater.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__